import { IOrder } from 'services/store/types/orders/Orders';

export const newOrderValidation = (order: IOrder): string[] => {
  const errors = [];
  if (!order.customer) errors.push('Wybierz klienta');
  if (!order.number) errors.push('Podaj numer projektu');
  return errors;
};
